import {
  type AdmissionAndFirstVisitWorkerRequirements,
  type AdmissionVisitWorkerRequirements,
  type DischargeVisitWorkerRequirements,
  type EvaluationVisitWorkerRequirements,
  VisitType,
  WorkerRequirements,
} from "@src/appV2/ExperimentalHomeHealth/Cases/types";

import { useHomeHealthQualificationGroups } from "./useHomeHealthQualificationGroups";

export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType.ADMISSION;
}): AdmissionVisitWorkerRequirements[];
export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType.DISCHARGE;
}): DischargeVisitWorkerRequirements[];
export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType.EVALUATION;
}): EvaluationVisitWorkerRequirements[];
export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType.ADMISSION_AND_FIRST_VISIT;
}): AdmissionAndFirstVisitWorkerRequirements[];
export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType;
}): WorkerRequirements[];
export function useHomeHealthQualificationsForVisitType(params: {
  visitType: VisitType;
}): WorkerRequirements[] {
  const { visitType } = params;
  const groups = useHomeHealthQualificationGroups();
  const includesPt = groups.pt.includes(WorkerRequirements.PT);

  switch (visitType) {
    case VisitType.EVALUATION: {
      return [WorkerRequirements.PT];
    }

    case VisitType.ADMISSION:
    case VisitType.DISCHARGE: {
      return includesPt ? [WorkerRequirements.RN, WorkerRequirements.PT] : [WorkerRequirements.RN];
    }

    case VisitType.REGULAR: {
      return [...groups.nonPt, ...groups.pt, ...groups.ot, ...groups.msw];
    }

    case VisitType.ADMISSION_AND_FIRST_VISIT:
    case VisitType.RESUMPTION_OF_CARE:
    case VisitType.RECERTIFICATION:
    case VisitType.SUPERVISORY: {
      return [WorkerRequirements.RN];
    }

    default: {
      return [];
    }
  }
}
